import React, { createContext, useContext, useState } from 'react';

const BreadcrumbContext = createContext();

export function BreadcrumbProvider({ children }) {
  const [itemTitle, setItemTitle] = useState(null);
  const [parentTitle, setParentTitle] = useState(null);

  return (
    <BreadcrumbContext.Provider value={{ itemTitle, setItemTitle, parentTitle, setParentTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return context;
}
